export const History = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0.0500488V3.08005C14.39 3.57005 17 6.47005 17 10C17 10.9 16.82 11.75 16.52 12.54L19.12 14.07C19.68 12.83 20 11.45 20 10C20 4.82005 16.05 0.550049 11 0.0500488ZM10 17C6.13 17 3 13.87 3 10C3 6.47005 5.61 3.57005 9 3.08005V0.0500488C3.94 0.550049 0 4.81005 0 10C0 15.52 4.47 20 9.99 20C13.3 20 16.23 18.39 18.05 15.91L15.45 14.38C14.17 15.98 12.21 17 10 17Z"
      fill="currentColor"
    />
  </svg>
);
